export class MockObjectStorage {
    async deleteFile() {
        throw new Error("unimplemented");
    }
    async getFile() {
        throw new Error("unimplemented");
    }
    async uploadFile() {
        return;
    }
    async presignedPutUrl(key, _contentType, _makePublic) {
        return `https://example.com/${key}`;
    }
}
//# sourceMappingURL=MockObjectStorage.js.map